/**
 * @name Travel
 * @function
 * @description 주변여행지
 */

import { ImgText } from "../components/ImgText";

export const Travel = (): JSX.Element => {
  return (
    <div>
      <ImgText title="Travel" text="주변여행지" />
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col sm:flex-row">
          <div className="pt-6 m-6 flex flex-col sm:flex-row sm:max-w-[20rem] lg:max-w-[35rem] rounded-xl bg-white bg-clip-border text-thickgray shadow-md">
            <div className="m-0 sm:w-2/5 shrink-0 overflow-hidden rounded-xl sm:rounded-r-none bg-white bg-clip-border text-thickgray">
              <img
                src="https://lh3.googleusercontent.com/p/AF1QipOnn7Z_feSaaEPrbPoUtq8YzVqpwayKiwDNcoj7=s680-w680-h510"
                alt="travel1"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="p-6">
              <h4 className="mb-2 block font-sans text-lg sm:text-2xl font-semibold leading-snug tracking-normal text-point antialiased">
                하남이성산성
              </h4>
              <p className="mb-8 block font-sans text-sm sm:text-base font-normal leading-relaxed text-thickgray antialiased">
                신라가 5세기 중엽 한강유역을 점령한 후 축조된 것으로
                역사상·학술상으로 매우 귀중한 유적으로 평가된다.
              </p>
              <a
                className="inline-block"
                href="https://www.korearank.com/tour/tour_detail.php?uid=32720"
              >
                <button
                  className="flex select-none items-center gap-2 rounded-lg py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-point transition-all hover:bg-point/10 active:bg-point/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                  type="button"
                >
                  상세정보
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-4 w-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                    ></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
          <div className="pt-6 m-6 flex flex-col sm:flex-row sm:max-w-[20rem] lg:max-w-[35rem] rounded-xl bg-white bg-clip-border text-thickgray shadow-md">
            <div className="m-0 sm:w-2/5 shrink-0 overflow-hidden rounded-xl sm:rounded-r-none bg-white bg-clip-border text-thickgray">
              <img
                src="https://lh3.googleusercontent.com/p/AF1QipO9sucTGV7CJokTj5vgjNe_HQnH78bpReCHNqkf=s680-w680-h510"
                alt="travel1"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="p-6">
              <h4 className="mb-2 block font-sans text-lg sm:text-2xl font-semibold leading-snug tracking-normal text-point antialiased">
                미사호수공원
              </h4>
              <p className="mb-8 block font-sans text-sm sm:text-base font-normal leading-relaxed text-thickgray antialiased">
                경기도 하남시 미사 강변도시를 개발하면서 망월천을 넓혀서 인공
                호수를 만들었고 그 주위에 공원을 조성하였다.
              </p>
              <a
                className="inline-block"
                href="https://www.korearank.com/tour/tour_detail.php?uid=49982"
              >
                <button
                  className="flex select-none items-center gap-2 rounded-lg py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-point transition-all hover:bg-point/10 active:bg-point/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                  type="button"
                >
                  상세정보
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-4 w-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                    ></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row">
          <div className="pt-6 m-6 flex flex-col sm:flex-row sm:max-w-[20rem] lg:max-w-[35rem] rounded-xl bg-white bg-clip-border text-thickgray shadow-md">
            <div className="m-0 sm:w-2/5 shrink-0 overflow-hidden rounded-xl sm:rounded-r-none bg-white bg-clip-border text-thickgray">
              <img
                src="https://www.ksponco.or.kr/boatracepark/galleryThumbView.es?bid=0037&list_no=5895"
                alt="travel1"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="p-6">
              <h4 className="mb-2 block font-sans text-lg sm:text-2xl font-semibold leading-snug tracking-normal text-point antialiased">
                미사경정공원
              </h4>
              <p className="mb-8 block font-sans text-sm sm:text-base font-normal leading-relaxed text-thickgray antialiased">
                카누경기를 위해 만들어진 공원
              </p>
              <a
                className="inline-block"
                href="https://www.ksponco.or.kr/boatracepark"
              >
                <button
                  className="flex select-none items-center gap-2 rounded-lg py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-point transition-all hover:bg-point/10 active:bg-point/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                  type="button"
                >
                  상세정보
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-4 w-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                    ></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
          <div className="pt-6 m-6 flex flex-col sm:flex-row sm:max-w-[20rem] lg:max-w-[35rem] rounded-xl bg-white bg-clip-border text-thickgray shadow-md">
            <div className="m-0 sm:w-2/5 shrink-0 overflow-hidden rounded-xl sm:rounded-r-none bg-white bg-clip-border text-thickgray">
              <img
                src="https://parks.seoul.go.kr/images/egovframework/com/template/gildong_01.jpg"
                alt="travel1"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="p-6">
              <h4 className="mb-2 block font-sans text-lg sm:text-2xl font-semibold leading-snug tracking-normal text-point antialiased">
                길동생태공원
              </h4>
              <p className="mb-8 block font-sans text-sm sm:text-base font-normal leading-relaxed text-thickgray antialiased">
                자연과 인간이 공존하는 길동생태공원
              </p>
              <a
                className="inline-block"
                href="https://parks.seoul.go.kr/template/sub/gildong.do"
              >
                <button
                  className="flex select-none items-center gap-2 rounded-lg py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-point transition-all hover:bg-point/10 active:bg-point/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                  type="button"
                >
                  상세정보
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    aria-hidden="true"
                    className="h-4 w-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                    ></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
